import WordService from "@/services/WordService";
import { root } from "@/common/consts";
import { getCurrentSubdomain } from "@/common/functions";
import RelatedInfo from "@/components/RelatedInfo/RelatedInfo.vue";

export default {
    components: {
        RelatedInfo
    },
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            root,
            mentions: [],
            error: false,
            subdomain: getCurrentSubdomain()
        };
    },
    computed: {
        title() {
            return this.subdomain === "sentence"
                ? this.$t("mentionedIn")
                : this.$t("thesaurusMentionedDictionaryCard", {
                      word: this.slug
                  });
        }
    },
    created() {
        this.refreshComponent();
    },
    watch: {
        $route() {
            this.refreshComponent();
        }
    },
    methods: {
        refreshComponent() {
            WordService.getMentions(this.slug).then(
                res => {
                    const mentions = res.data.data.mentions;
                    if (mentions.length < 1) {
                        this.error = true;
                    } else if (mentions.length >= 1) {
                        this.error = false;
                        this.mentions = mentions;
                    }
                },
                err => (this.error = true)
            );
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/MentionedIn/MentionedIn.js